import { CheckIcon } from '@heroicons/react/solid'
import { ForwardedRef, forwardRef } from 'react'
import { classNames } from './utils'

interface CheckboxProps
  extends Omit<JSX.IntrinsicElements['input'], 'className' | 'type' | 'size'> {
  variant?: 'primary' | 'danger'
  size?: 'md' | 'lg'
}

export const Checkbox = forwardRef(function Checkbox(
  {
    variant = 'primary',
    size = 'md',
    disabled,
    checked,
    children,
    ...props
  }: CheckboxProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  return (
    <label
      className={classNames('inline-flex items-center space-x-2', {
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled
      })}>
      <span className="relative inline-flex">
        <input
          ref={ref}
          type="checkbox"
          {...props}
          disabled={disabled}
          checked={checked}
          className={classNames(
            'peer appearance-none rounded border-2 bg-white outline-none focus:ring-2 focus:ring-offset-2',
            {
              'border-gray-300 checked:border-brand-primary checked:bg-brand-primary focus:ring-brand-primary':
                variant === 'primary',
              'border-red-300 checked:border-red-500 checked:bg-red-500 focus:ring-red-500':
                variant === 'danger',

              'h-4 w-4': size === 'md',
              'h-5 w-5': size === 'lg',

              'bg-gray-50': disabled
            }
          )}
        />
        <CheckIcon
          className={classNames(
            'absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 text-white peer-checked:flex',
            {
              'h-4 w-4': size === 'md',
              'h-5 w-5': size === 'lg'
            }
          )}
        />
      </span>
      {!!children && (
        <span
          className={classNames('font-medium text-gray-500', {
            'text-xs': size === 'md',
            'text-sm': size === 'lg'
          })}>
          {children}
        </span>
      )}
    </label>
  )
})
